<template>
  <div class="dashboardUnAuth">
    <div class="title">Welcome</div>
    <div class="subTitle">{{ l("欢迎进入中锻材后台管理系统") }}</div>
    <TenantManagerInfo />
    <!-- <div style="display: flex; justify-content: center; margin-top: 30px">
      <el-image
        :src="GetResourceUrl('backend/unAuth.jpg')"
        fit="cover"
        style="width: 485px; height: 248px"
      >
      </el-image>
    </div> -->
    <div
      class="waiting"
      v-if="
        $store.state.session.tenant_auth &&
        $store.state.session.tenant_auth.status == 0
      "
    >
      {{ l("认证审核中，请耐心等待") }}
    </div>
    <div v-else class="buttonList">
      <div class="button" @click="goTenantAuth">
        {{ l("立即前往企业认证") }}
      </div>
    </div>
    <div class="tableTitle">
      <div class="midline"></div>
      <div class="midtitle">
        <el-image
          :src="GetResourceUrl('backend/icon-auth.svg')"
          fit="cover"
          style="width: 12px; height: 16px; margin-right: 10px"
        >
        </el-image>
        <div>{{ l("认证后解锁更多权益") }}</div>
      </div>
      <div class="midline"></div>
    </div>
    <el-table
      class="auth_table"
      :data="[
        [l('未认证'), 0, 0, 0, 0, 1, 1, -1],
        [l('企业认证'), 1, 1, 1, 1, 1, 1, 1],
      ]"
      border
    >
      <el-table-column label="" :resizable="false" min-width="120">
        <template slot-scope="scope">
          <div style="font-size: 16px">{{ scope.row[0] }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="l('发布商品')" :resizable="false">
        <template slot-scope="scope">
          <i v-show="scope.row[1] == 1" class="el-icon-check"></i>
          <span v-show="scope.row[1] == 0">受限</span>
          <span v-show="scope.row[1] == -1">无</span>
        </template>
      </el-table-column>
      <el-table-column :label="l('发布需求')" :resizable="false">
        <template slot-scope="scope">
          <i v-show="scope.row[2] == 1" class="el-icon-check"></i>
          <span v-show="scope.row[2] == 0">受限</span>
          <span v-show="scope.row[2] == -1">无</span>
        </template>
      </el-table-column>
      <el-table-column :label="l('询价')" :resizable="false">
        <template slot-scope="scope">
          <i v-show="scope.row[3] == 1" class="el-icon-check"></i>
          <span v-show="scope.row[3] == 0">受限</span>
          <span v-show="scope.row[3] == -1">无</span>
        </template>
      </el-table-column>

      <el-table-column :label="l('报价')" :resizable="false">
        <template slot-scope="scope">
          <i v-show="scope.row[4] == 1" class="el-icon-check"></i>
          <span v-show="scope.row[4] == 0">受限</span>
          <span v-show="scope.row[4] == -1">无</span>
        </template>
      </el-table-column>
      <el-table-column :label="l('参与拼单')" :resizable="false">
        <template slot-scope="scope">
          <i v-show="scope.row[5] == 1" class="el-icon-check"></i>
          <span v-show="scope.row[5] == 0">受限</span>
          <span v-show="scope.row[5] == -1">无</span>
        </template>
      </el-table-column>
      <el-table-column :label="l('质检委托')" :resizable="false">
        <template slot-scope="scope">
          <i v-show="scope.row[6] == 1" class="el-icon-check"></i>
          <span v-show="scope.row[6] == 0">受限</span>
          <span v-show="scope.row[6] == -1">无</span>
        </template>
      </el-table-column>
      <el-table-column :label="l('论坛交流')" :resizable="false">
        <template slot-scope="scope">
          <i v-show="scope.row[7] == 1" class="el-icon-check"></i>
          <span v-show="scope.row[7] == 0">受限</span>
          <span v-show="scope.row[7] == -1">无</span>
        </template>
      </el-table-column>
    </el-table>

    <TenantAuth
      ref="TenantAuth"
      @submitDialog="$store.dispatch('updateSession')"
    />
  </div>
</template>

<script>
import TenantAuth from "./operation/TenantAuth.vue";
import TenantManagerInfo from "./TenantManagerInfo.vue";

export default {
  name: "DashboardUnAuth",
  components: {
    TenantAuth,
    TenantManagerInfo,
  },
  data() {
    return {};
  },

  mounted() {},
  beforeDestroy() {},
  methods: {
    goTenantAuth() {
      this.$refs.TenantAuth.Type = "Create";
      this.$refs.TenantAuth.Show();
    },
  },
};
</script>

<style scoped lang="scss">
.dashboardUnAuth {
  background: #fff;
  padding: 40px 60px;

  .title {
    color: $warningColor;
    font-size: 46px;
    text-align: center;
  }
  .subTitle {
    font-size: 16px;
    letter-spacing: 1.5px;
    color: #666;
    text-align: center;
    margin-top: 15px;
  }
  .waiting {
    color: $warningColor;
    margin-top: 30px;
    font-size: 22px;
    text-align: center;
  }
  .buttonList {
    display: flex;
    justify-content: center;
    margin-top: 30px;
    letter-spacing: 1px;
    font-size: 16px;
    .button {
      box-sizing: border-box;
      border: 1px solid $warningColor;
      color: $warningColor;
      border-radius: 30px;
      padding: 12px 45px;
      margin: 0 60px;
      font-weight: bold;
      cursor: pointer;
      background: #fdf9f7;
      &:hover {
        color: #fff;
        background: $warningColor;
      }
    }
  }
  .tableTitle {
    margin-top: 50px;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    .midtitle {
      display: flex;
      align-items: center;
      flex-shrink: 0;
      margin: 0 30px;
    }
    .midline {
      height: 1px;
      flex-grow: 1;
      background: $borderPlainColor;
    }
  }
  .auth_table {
    margin: 40px 0;
    box-shadow: none;
    /deep/.el-table__header-wrapper {
      font-size: 13px;
      letter-spacing: 1px;
      .el-table__cell {
        background: #fefcfb;
      }
    }
    /deep/i {
      color: $warningColor;
      font-size: 18px;
      font-weight: bold;
    }
  }
}
</style>

